import moment from "jalali-moment";

export function convertUniversalDateToPersianDate(date) {
    if (date && date.length > 0) {
        return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
    }
}

export function convertPersianDateToUniversalDate(date) {
    if (date && date.length > 0) {
        return moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    } else
        return ""
}


